import { Record } from '../transit'

const User = Record({
  id: '',
  _id: '',
  email: '',
  picture: '',
  name: '',
  firstName: '',
  lastName: '',
  picturePath: '',
  role: '',
  authType: '',
  deactivatedAt: null,
  lastActiveAt: null,
  following: [],
  followers: [],
  userLessons: [],
  favoriteLessons: [],
  groups: [],
  subjects: [],
  userLanguage: 'en',
  foreignLanguage: 'es',
  learningLanguage: '',
  statistics: null,
  tests: [],
  results: [],
  practices: [],
  seenGuides: {
    testAddress: false,
    exercisePage: false,
    testDescription: false,
    homeworkDescription: false,
    wordboxDescription: false,
    optionsDescription: false,
    translationDescription: false,
  },
  tokens: {
    access: '',
  },
}, 'user')

export default User



// WEBPACK FOOTER //
// ./src/common/users/User.js